const storageKey = () => `bulk-talent-id-uploads:${process.env.REACT_APP_TENANT_ID || 'default'}`

const emptyRegistry = () => ({
  uids: [],
  updatedAt: {}
})

const loadRegistry = () => {
  try {
    const raw = window.localStorage.getItem(storageKey())
    if (!raw) return emptyRegistry()

    const parsed = JSON.parse(raw)
    return {
      uids: Array.isArray(parsed.uids) ? parsed.uids : [],
      updatedAt: parsed.updatedAt && typeof parsed.updatedAt === 'object' ? parsed.updatedAt : {}
    }
  } catch {
    return emptyRegistry()
  }
}

const saveRegistry = (registry) => {
  window.localStorage.setItem(storageKey(), JSON.stringify(registry))
}

export const recordBulkTalentIdUpload = (employeeUid) => {
  if (!employeeUid) return

  const registry = loadRegistry()
  const uidSet = new Set(registry.uids)
  uidSet.add(employeeUid)

  saveRegistry({
    uids: [...uidSet],
    updatedAt: {
      ...registry.updatedAt,
      [employeeUid]: new Date().toISOString()
    }
  })
}

export const getBulkTalentIdUploadUpdatedAt = (employeeUid) => {
  if (!employeeUid) return null
  return loadRegistry().updatedAt[employeeUid] || null
}
